<template>
  <el-dialog title="Transferir motorista" :append-to-body="true" center :visible.sync="dialog" width="80%">
    <el-form>
      <el-form-item :label="$t('motorista')">
        <el-select v-model="driver" ref="driver" clearable placeholder="Definir motorista" @clear="driver = null">
          <el-option v-for="item in tableDrivers" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click.stop.prevent="dialog = false">Cancelar</el-button>
      <el-button type="primary" @click.stop.prevent="transfer">Transferir</el-button>
    </span>
  </el-dialog>      
</template>

<script>
import { DriversService } from "@/services/customers/drivers.services";
import { RouteService } from "@/services/umov/route.services";

export default {
  name: "TransferRouteDriver",
  data() {
    return {
      tableDrivers: [],
      dialog: false,
      driver: "",
      id: "",
    }
  },
  methods: {
    fetch() {
      const vm = this;
      DriversService.list()
        .then((response) => {
          vm.tableDrivers = response.sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch((error) => {
          return this.$message({ type: "error", duration: 5000, message: error });
        });
    },

    transfer() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.transfer({
        id: vm.id,
        driver: vm.driver,
      })
      .then((response) => {
        this.dialog = false;
        vm.$message({
          type: "success",
          message: "Rota transferida com sucesso",
        });
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      })
      .finally(() => loading.close());
    },
    open(id) {
      console.log('transfer open')
      this.id = id;
      this.dialog = true;
    }
  },
  mounted() {
    this.fetch();
  }
}
</script>